import { set, transform, merge } from 'lodash';

export const transformDotNotationObject = (obj: any) => transform(obj, (result, value, key) => {
  set(result, key, value);
}, {});

export const mergeObjects = (objs: any[]) => merge({}, ...objs);
